import {
  ARIAL_FONT,
  LIBERATION_SANS_FONT,
  LIBERATION_SERIF_FONT,
  LIBERATION_MONO_FONT
} from 'pxc-editor-material-svg-rendering/constants';
import { getCurrentEnvironment, isPrime2Environment } from '@/helpers';
import { APP_ENVIRONMENT } from '@/constants';

export default function calculateFontSizeCoef(platform) {
  const currentEnvironment = getCurrentEnvironment();

  switch (currentEnvironment) {
    case APP_ENVIRONMENT.XCORE: {
      const prime2Environment = isPrime2Environment(platform.config.environment);
      if (prime2Environment) {
        return {
          [ARIAL_FONT]: 1.33,
          [LIBERATION_SANS_FONT]: 1.35,
          [LIBERATION_SERIF_FONT]: 1.35,
          [LIBERATION_MONO_FONT]: 1.35,
        }
      }
    }
    case APP_ENVIRONMENT.CLIPX_WEB:
    case APP_ENVIRONMENT.WEB_COMPONENT: {
      return {
        [ARIAL_FONT]: 1.4292,
        [LIBERATION_SANS_FONT]: 1.4292,
        [LIBERATION_SERIF_FONT]: 1.4292,
        [LIBERATION_MONO_FONT]: 1.4292,
      }
    }
    default: {
      return {
        [ARIAL_FONT]: 1,
        [LIBERATION_SANS_FONT]: 1,
        [LIBERATION_SERIF_FONT]: 1,
        [LIBERATION_MONO_FONT]: 1,
      };
    }
  }
}
